<template>
<!-- CONTACT US  联系我们 -->
  <div class="contact-page">
    <!-- 导航栏 -->
    <Nav />
    <!-- 英雄区域 -->
    <section class="hero slide-in-top">
      <div class="hero-content">
        <h1>
          <span class="text-slide">WELCOME TO CONTACT WITH US!</span>
          <span class="text-slide text-delay"></span>
        </h1>
      </div>
      <div class="hero-bg">
        <img src="@/assets/banner.jpg" alt="QINYUAN GROUP Global Business Contact Official Banner">
      </div>
    </section>
    <!-- 全球办公联络信息板块 -->
    <section class="global-contact-section slide-in-bottom">
      <div class="container">
        <h2 class="global-section-title">GLOBAL OFFICE CONTACTS</h2>
        <div class="global-contact-card">
          <!-- 上海总部 -->
          <div class="contact-block shanghai-block">
            <h3 class="block-title">SHANGHAI HEAD OFFICE</h3>
            <p class="block-address">ADDRESS: ROOM200:5,NO.609 YINXIANG ROAD,JIADING DISTRICT,SHANGHAI,CHINA ZIP 201802.
            </p>
            <div class="dept-block">
              <h4>FOR GENERAL COOPERATION:</h4>
              <p>CONTACT MR.JACKNI</p>
              <p>WHATSAPP/WECHAT: +8618149795331</p>
              <p>EMAIL: <a href="mailto:JACKNI@QINYUANCORP.CN">JACKNI@QINYUANCORP.CN</a></p>
            </div>
            <div class="dept-block">
              <h4>FOR LEATHER DEPARTMENT：</h4>
              <p>CONTACT MISS.MONICA</p>
              <p>WHATSAPP/WECHAT: +8613661715907</p>
              <p>EMAIL: <a href="mailto:SALES@QINYUANCORP.CN">SALES@QINYUANCORP.CN</a></p>
            </div>
            <div class="dept-block">
              <h4>FOR SHIPPING COOPERATION:</h4>
              <p>CONTACT EMMA</p>
              <p>WECHAT: +8615821557964</p>
              <p>EMAIL: <a href="mailto:DOCUMENTS@QINYUANCORP.CN">DOCUMENTS@QINYUANCORP.CN</a></p>
            </div>

          </div>
          <!-- 海外办事处 -->
          <div class="contact-block overseas-block">
            <h3 class="block-title">OVERSEAS OFFICES</h3>
            <!-- 伊朗办事处 -->
            <div class="office-block">
              <h4>IRAN OFFICE:</h4>
              <p>ROOM NO. 209 second floor AT the corner of mehrara alley, mehran street, TEHRAN</p>
              <p class="persian-address">شهرک شريعتی خيابان مهران نبش کوچه مهرآرا مجتمع مسکونی طبقه دوم واحد ٢</p>
              <p>MOB: +989304480689</p>
            </div>
            <!-- 俄罗斯办事处 -->
            <div class="office-block">
              <h4>RUSSIA OFFICE</h4>
            </div>
            <!-- 迪拜办事处 -->
            <div class="office-block">
              <h4>DUBAI OFFICE</h4>
            </div>
            <!-- 土耳其办事处 -->
            <div class="office-block">
              <h4>TURKEY OFFICE</h4>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- 联系我们区域 -->
    <section class="contact-section">
      <div class="container">
        <div class="contact-wrapper">
          <!-- 左侧内容 -->
          <div class="contact-left slide-in-left">
            <h2 class="section-title">GET IN TOUCH WITH US</h2>
            <p class="section-subtitle">
              We are eager to connect with you and explore how we can contribute to your success.
            </p>
            <div class="contact-image">
              <img src="@/assets/banner.jpg"
                alt="QINYUAN GROUP International Business Cooperation Global Trade Negotiation">
            </div>
            <div class="contact-info">
              <p class="address">
                <i class="icon-location"></i>
                <!-- SHANGHAI HEAD OFFICE 
                ADDRESS: ROOM200:5,NO.609 YINXIANG ROAD,JIADING DISTRICT,SHANGHAI -->
              </p>
              <p class="phone">
                <i class="icon-phone"></i>
                <!-- CHINA ZIP 201802 -->
              </p>

            </div>
          </div>
          <!-- 右侧表单 -->
          <div class="contact-right slide-in-right">
            <form class="contact-form">
              <input type="text" class="form-input scale-in" placeholder="YOUR COMPANY NAME" required>
              <input type="text" class="form-input scale-in" placeholder="Your Name" required>
              <input type="tel" class="form-input scale-in" placeholder="YOUR MOBILE NUMBER/WHATSAPP:" required />
              <input type="email" class="form-input scale-in" placeholder="YOUR EMAIL" required>
              <input type="text" class="form-input scale-in" placeholder="WHICH PRODUCTS YOU ARE INTERESTED" required>
              <textarea class="form-input form-textarea scale-in" placeholder="LEAVE A MESSAGE WE WILL CONTACT YOU SOON"
                rows="5" required></textarea>
              <button type="submit" class="submit-btn slide-in-bottom">Submit</button>
            </form>
          </div>
        </div>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
export default {
  name: "Careers",
  data() {
    return {
      animatedElements: [],
    };
  },
  mounted() {
    // 页面SEO独立配置 谷歌+百度双收录
    document.title =
      "CONTACT US - QINYUAN GROUP | Global Polyurethane PVC EVA Chemical Raw Material Supplier";
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement("meta");
      metaDesc.name = "description";
      document.head.appendChild(metaDesc);
    }
    metaDesc.content =
      "QINYUAN GROUP has head office in Shanghai and overseas branches in Iran, Russia, Dubai and Turkey. We supply polyurethane, PVC, EVA chemical raw materials, production machinery and professional technical service, welcome global business cooperation and inquiry.";

    let metaKey = document.querySelector('meta[name="keywords"]');
    if (!metaKey) {
      metaKey = document.createElement("meta");
      metaKey.name = "keywords";
      document.head.appendChild(metaKey);
    }
    metaKey.content =
      "QINYUAN GROUP,contact us,global chemical supplier,polyurethane raw material,PVC industrial material,EVA copolymer material,Shanghai chemical enterprise,overseas business cooperation";

    this.animatedElements = document.querySelectorAll(
      ".slide-in-top, .slide-in-bottom, .slide-in-left, .slide-in-right, .scale-in"
    );
    this.autoAnimate();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    autoAnimate() {
      this.animatedElements.forEach((element, index) => {
        setTimeout(() => {
          element.classList.add("animated");
        }, 300 * index);
      });
    },
    handleScroll() {
      const windowHeight = window.innerHeight;
      this.animatedElements.forEach((element) => {
        const elementTop = element.getBoundingClientRect().top;
        if (elementTop < windowHeight * 0.7) {
          element.classList.add("animated");
        }
      });
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Inter", "Arial", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.contact-page {
  min-height: 100vh;
  background-color: #fdfdfd;
  overflow-x: hidden;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 2.5rem;
}

/* 英雄区域*/
.hero {
  height: 480px;
  background: transparent;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
}
.hero-content {
  width: 60%;
  padding: 0 0 0 12rem;
  text-align: left;
  position: relative;
  z-index: 2;
}
.hero-content h1 {
  font-size: 2.5rem;
  letter-spacing: 1px;
  color: #fff;
  margin: 0;
  line-height: 1.2;
  font-weight: 800;
}
.hero-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}
.hero-bg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.hero::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    #e02020 0%,
    #e02020 40%,
    rgba(224, 32, 32, 0) 100%
  );
  z-index: 1;
}
.text-slide {
  display: inline-block;
  opacity: 0;
  transform: translateX(-60px) translateY(20px);
  animation: textSlideIn 1s cubic-bezier(0.19, 1, 0.22, 1) forwards;
  font-weight: 800;
}
.text-delay {
  animation-delay: 0.4s;
}
@keyframes textSlideIn {
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
/* 全球办公联络信息板块  */
.global-contact-section {
  padding: 6rem 0 8rem;
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.global-contact-section.animated {
  opacity: 1;
  transform: translateY(0);
}
/* 板块标题 */
.global-section-title {
  font-size: 2.2rem;
  font-weight: 700;
  color: #222;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 4rem;
  position: relative;
  letter-spacing: 1px;
}
.global-section-title::after {
  content: "";
  position: absolute;
  bottom: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  height: 2px;
  background-color: #e02020;
  border-radius: 1px;
}
/* 联络卡片 */
.global-contact-card {
  display: grid;
  grid-template-columns: 2.2fr 1fr;
  gap: 4rem;
  background-color: #ffffff;
  padding: 4rem;
  border-radius: 16px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.03);
  border: 1px solid #f5f5f5;
}
/* 区块标题 */
.contact-block .block-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: #e02020;
  margin-bottom: 2.5rem;
  padding-bottom: 1.2rem;
  border-bottom: 1px solid #eee;
  text-transform: uppercase;
  letter-spacing: 1px;
}
/* 上海总部子区块 */
.shanghai-block .dept-block {
  margin-bottom: 3rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid #f2f2f2;
}
.shanghai-block .dept-block:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}
/* 海外办事处子区块*/
.overseas-block .office-block {
  margin-bottom: 2.5rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #f2f2f2;
}
.overseas-block .office-block:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}
/* 子标题 */
.dept-block h4,
.office-block h4 {
  font-size: 1.05rem;
  font-weight: 600;
  color: #222;
  margin-bottom: 1rem;
  text-transform: capitalize;
}
/* 内容文本 */
.dept-block p,
.office-block p {
  font-size: 0.95rem;
  color: #555;
  line-height: 1.8;
  margin-bottom: 0.6rem;
}
/* 邮箱链接 */
.dept-block a {
  color: #e02020;
  text-decoration: none;
  position: relative;
}
.dept-block a::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 1px;
  background-color: #e02020;
  transition: width 0.3s ease;
}
.dept-block a:hover::after {
  width: 100%;
}
/* 上海总部地址 */
.block-address {
  font-size: 0.98rem;
  color: #444;
  line-height: 1.8;
  margin-bottom: 3rem;
  padding-left: 0.2rem;
}
/* 波斯语地址 */
.persian-address {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  direction: rtl;
  color: #444;
  margin: 1rem 0;
  padding: 0.8rem 1rem;
  background-color: #f8f8f8;
  border-radius: 6px;
  border-left: 2px solid #e02020;
  font-size: 0.9rem;
  line-height: 1.7;
}

/* 联系我们区域 */
.contact-section {
  padding: 0 0 6rem;
}
.contact-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5rem;
  align-items: start;
}
/* 左侧内容 */
.contact-left {
  opacity: 0;
  transform: translateX(-50px);
  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.contact-left.animated {
  opacity: 1;
  transform: translateX(0);
}
.section-title {
  font-size: 1.6rem;
  font-weight: 700;
  color: #e02020;
  margin-bottom: 1.2rem;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.section-subtitle {
  color: #666;
  font-size: 1rem;
  line-height: 1.7;
  margin-bottom: 3rem;
}
/* 左侧图片 */
.contact-image {
  margin-bottom: 2.5rem;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.04);
}
.contact-image img {
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.5s ease;
}
.contact-image:hover img {
  transform: scale(1.03);
}
/* 左侧联系信息*/
.contact-info {
  color: #555;
  font-size: 0.95rem;
}
.contact-info p {
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  line-height: 1.7;
}
.contact-info i {
  margin-right: 0.8rem;
  color: #e02020;
  font-size: 1.1rem;
}

/* 右侧表单 */
.contact-right {
  opacity: 0;
  transform: translateX(50px);
  transition: all 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}
.contact-right.animated {
  opacity: 1;
  transform: translateX(0);
}
.contact-form {
  background-color: #ffffff;
  padding: 3rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  border-radius: 16px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.03);
  border: 1px solid #f5f5f5;
}
/* 表单输入框  */
.form-input {
  padding: 1rem 1.2rem;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  background-color: #ffffff;
  opacity: 0;
  transform: scale(0.9);
}
.form-input.animated {
  opacity: 1;
  transform: scale(1);
}
.form-input:focus {
  outline: none;
  border-color: #e02020;
  box-shadow: 0 0 0 3px rgba(224, 32, 32, 0.08);
  border-width: 1px;
}
.form-textarea {
  resize: vertical;
  min-height: 120px;
  line-height: 1.7;
}
/* 提交按钮  */
.submit-btn {
  background-color: #e02020;
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  opacity: 0;
  transform: translateY(20px);
  align-self: flex-start;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.submit-btn.animated {
  opacity: 1;
  transform: translateY(0);
}
.submit-btn:hover {
  background-color: #c91c1c;
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(224, 32, 32, 0.2);
}

/* 响应式移动端适配 无修改原有逻辑 */
@media (max-width: 992px) {
  .container {
    padding: 0 1.5rem;
  }
  /* 英雄区响应式 */
  .hero {
    height: 380px;
    background: transparent;
  }
  .hero-content {
    width: 100%;
    padding: 0 2rem;
    text-align: center;
  }
  .hero-content h1 {
    font-size: 2.2rem;
    letter-spacing: 1px;
  }
  .hero-bg {
    display: block;
  }
  /* 全球联络板块响应式 */
  .global-contact-section {
    padding: 4rem 0 6rem;
  }
  .global-section-title {
    font-size: 1.8rem;
    margin-bottom: 3rem;
  }
  .global-contact-card {
    grid-template-columns: 1fr;
    gap: 3rem;
    padding: 2.5rem;
  }
  /* 联系区域响应式 */
  .contact-section {
    padding: 0 0 7rem;
  }
  .contact-wrapper {
    grid-template-columns: 1fr;
    gap: 3rem;
  }
  .contact-form {
    padding: 2rem;
  }
  /* 页脚响应式 */
  .footer-content {
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
  }
  .page-footer {
    padding: 4rem 0 2rem;
  }
}

@media (max-width: 768px) {
  /* 全局适配 */
  .container {
    padding: 0 1rem;
  }
  /* 英雄区适配 */
  .hero {
    height: 320px;
  }
  .hero-content h1 {
    font-size: 1.8rem;
  }
  /* 全球联络板块适配 */
  .global-contact-card {
    padding: 2rem 1.5rem;
    border-radius: 12px;
  }
  .contact-block .block-title {
    font-size: 1.2rem;
    margin-bottom: 2rem;
  }
  .persian-address {
    padding: 0.6rem 0.8rem;
    font-size: 0.85rem;
  }
  /* 联系区域适配 */
  .contact-section {
    padding: 0 0 6rem;
  }
  .section-title {
    font-size: 1.4rem;
  }
  .contact-form {
    padding: 1.5rem;
    gap: 1.2rem;
  }
  .form-input {
    padding: 0.9rem 1rem;
  }
  .submit-btn {
    padding: 0.9rem 1.5rem;
    font-size: 0.95rem;
  }
}
</style>